import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivityInterface, WorkflowStepInterface } from '@vendasta/automata';
import { SalesOpportunitiesService as SalesOpportunitiesApiService } from '@vendasta/sales-opportunities';
import { Observable } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { ActivityTableEntry, AutomationDisplayService, NodeData } from '../../common/automation-display.service';
import { options } from './query-opportunities-panel/query-opportunities-panel.component';

@Injectable({ providedIn: 'root' })
export class QueryOpportunitiesService extends AutomationDisplayService {
  constructor(
    protected readonly translateService: TranslateService,
    private readonly salesOpportunityService: SalesOpportunitiesApiService,
  ) {
    super();
  }

  /** Gets text for the activity column in the table. */
  getActivityColumn(_namespace: string, activity: ActivityInterface): ActivityTableEntry {
    const activityData = activity?.activityData ? JSON.parse(activity.activityData) : {};
    if (!activityData.opportunity_id) {
      return this.tableEntry(
        this.translateService.stream('AUTOMATIONS.EDITOR.TASKS.QUERY_OPPORTUNITIES.QUERY_OPPORTUNITIES'),
        this.translateService.stream('AUTOMATIONS.EDITOR.TASKS.QUERY_OPPORTUNITIES.OPPORTUNITY_NOT_FOUND'),
      );
    }

    return this.tableEntry(
      this.translateService.stream('AUTOMATIONS.EDITOR.TASKS.QUERY_OPPORTUNITIES.QUERY_OPPORTUNITIES'),
      this.salesOpportunityService.get(activityData.opportunity_id, activity?.entityId).pipe(
        take(1),
        map((opportunity) => {
          if (!opportunity) {
            return this.translateService.instant('AUTOMATIONS.EDITOR.TASKS.QUERY_OPPORTUNITIES.OPPORTUNITY_NOT_FOUND');
          }
          return this.translateService.instant('AUTOMATIONS.EDITOR.TASKS.QUERY_OPPORTUNITIES.FOUND_OPPORTUNITY', {
            opportunityName: opportunity.name,
          });
        }),
        catchError((err) => {
          console.error(err);
          return this.translateService.stream('AUTOMATIONS.EDITOR.TASKS.QUERY_OPPORTUNITIES.OPPORTUNITY_NOT_FOUND');
        }),
      ),
    );
  }

  /** The text in an automation node (i.e. the nodes in the graph). */
  getAutomationNodeData(
    _namespace: string,
    step: WorkflowStepInterface,
    _isWaitUntilNode: boolean,
  ): Observable<NodeData> {
    const workflowStepData = step?.data ? JSON.parse(step.data) : {};
    const field = workflowStepData?.sort_field;
    const direction = workflowStepData?.sort_direction;
    const label = options.find((o) => o.value.id == field && o.value.direction == direction)?.label;
    return this.nodeDisplayData(
      this.translateService.stream('AUTOMATIONS.EDITOR.TASKS.QUERY_OPPORTUNITIES.ACTIVITY_2', {
        field: this.translateService.instant(label)?.toLowerCase(),
      }),
      this.noValidationErrorsDetected(),
    );
  }
}
